<template>
    <div class="context_add">
        <div class="header">
            <div class="search">
                <el-page-header @back="back" :content="roleTitle">
                </el-page-header>
            </div>
        </div>
        <div class="text_main" :class="look?'look_text_main':''">
            <div class="form_box">
                <div class="form_item">
                    <div class="title">
                        <span style="color: red">*</span> 角色名称:
                    </div>
                    <div class="input_box">
                        <el-input v-model="roleForm.name"
                                  clearable
                                  :disabled="look"
                                  class="width_400"
                                  size="small"></el-input>
                    </div>
                </div>
                <div class="form_item">
                    <div class="title">
                        角色备注:
                    </div>
                    <div class="input_box">
                        <el-input v-model="roleForm.remark"
                                  clearable
                                  :disabled="look"
                                  type="textarea"
                                  class="width_all"
                                  size="small"></el-input>
                    </div>
                </div>
            </div>
            <div class="tree_box">
                <div class="table_title">
                    <div>模块</div>
                    <div>功能</div>
                    <div>操作</div>
                </div>
                <div class="tree_item"
                     v-for="(item, index) in treeData"
                     :key="index">
                    <div class="one_box">
                        <el-checkbox :indeterminate="tree[index].isIndeterminate"
                                     @change="(val) => {oneChange(val, item, tree[index])}"
                                     v-model="tree[index].checkAll"
                                     :disabled="look">
                            {{item.alias}}
                        </el-checkbox>
                    </div>
                    <!---->
                    <div class="two_box">
                        <div v-for="(item2, index2) in item.children"
                             class="dis_two"
                             :key="index2">
                            <div class="three_box">
                                <el-checkbox :indeterminate="tree[index].children[index2].isIndeterminate"
                                             @change="(val) => {twoChange(val,item2, tree[index].children[index2], tree[index]) }"
                                             v-model="tree[index].children[index2].checkAll"
                                             :disabled="look">
                                    {{item2.alias}}
                                </el-checkbox>
                            </div>
                            <div class="four_box">
                                <el-checkbox-group :disabled="look"
                                                   v-model="tree[index].children[index2].list"
                                                   style="display: flex"
                                                   @change="(val) => {
                                   threeChange(
                                   val,
                                    item2,
                                     tree[index].children[index2],
                                      tree[index])}">
                                    <el-checkbox v-for="(item3, index3) in item2.children"
                                                 :key="item3.name"
                                                 class="span_item"
                                                 :label="item3.name">
                                        {{item3.alias}}
                                    </el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="bottom" v-if="!look">
            <div class="btn-box">
                <el-button size="small"
                           @click="back"
                           class="table-btn">取消
                </el-button>
                <el-button size="small"
                           type="primary"
                           @click="submit"
                           class="newBtn">提交
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import {clone} from "@/global/utils";
    import {mapState} from "vuex";
    import authList from "@/global/authorityList"

    export default {
        name: "edit",
        data() {
            return {
                roleForm: {
                    name: '',
                    remark: '',
                    role_id: '',
                },
                treeData: [],
                tree: [],
                checkAll: false,
            }
        },
        computed: {
            ...mapState('sysUserData', {
                look: 'look',
                form: 'roleForm',
                roleTitle: 'roleTitle',
                authority: 'authority'
            })
        },
        mounted() {
            this.getCheckOptions();
            this.getRoleForm()

        },
        methods: {
            getRoleForm() {
                this.roleForm = clone(this.form);
                console.log(this.roleForm, '171');
            },

            oneChange(val, item, tree) {
                console.log(val, item, tree);
                tree.isIndeterminate = false;
                tree.children.forEach(v => {
                    v.checkAll = val;
                    v.isIndeterminate = false;
                });
                item.children.forEach((v, index) => {
                    this.twoChange(val, v, tree.children[index], tree, true)
                })
            },
            twoChange(val, item, tree, treeOne, con) {
                let data = [];
                item.children.forEach(v => data.push(v.name));
                tree.list = val ? data : [];
                tree.isIndeterminate = false;
                if (!con) {
                    this.changeOne(treeOne)
                }
            },
            threeChange(val, item, tree, treeOne) {
                let checkedCount = val.length;
                tree.list = val;
                tree.checkAll = checkedCount === item.children.length;
                tree.isIndeterminate = checkedCount > 0 && checkedCount < item.children.length;
                this.changeOne(treeOne)
            },
            changeOne(tree) {
                let c_num = 0;
                let i_num = 0;
                tree.children.forEach(v => {
                    if (v.checkAll) {
                        c_num += 1
                    }
                    if (v.isIndeterminate) {
                        i_num += 1
                    }
                });
                if (c_num === tree.children.length) {
                    tree.isIndeterminate = false;
                    tree.checkAll = true
                } else if (c_num > 0 || i_num > 0) {
                    tree.isIndeterminate = true;
                    tree.checkAll = false
                } else {
                    tree.isIndeterminate = false;
                    tree.checkAll = false
                }
            },
            getCheckOptions() {
                this.treeData = clone(authList);
                this.getTree();
            },
            getTree() {
                let that = this;
                that.tree = [];
                that.treeData.forEach((v, index) => {
                    that.tree.push({
                        checkAll: false,
                        isIndeterminate: false,
                        children: []
                    });
                    v.children.forEach((e, index2) => {
                        that.tree[index].children.push({
                            checkAll: false,
                            isIndeterminate: false,
                            list: []
                        })
                    })
                });
                that.$nextTick(() => {
                    setTimeout(() => {
                        that.treeData.forEach((v, index) => {
                            v.children.forEach((e, index2) => {
                                let data = [];
                                that.authority.forEach(item => {
                                    if (item.indexOf(e.name) > -1) {
                                        data.push(item)
                                    }
                                });
                                this.threeChange(
                                    data,
                                    e,
                                    that.tree[index].children[index2],
                                    that.tree[index])
                            })
                        })
                    }, 50)
                })
            },
            submit() {
                if (this.roleForm.role_name == '') {
                    this.$message.warning('请输入角色名称!');
                    return
                }
                let data = [];
                this.tree.forEach(v => {
                    v.children.forEach(e => {
                        data = [...data, ...e.list]
                    })
                });
                let params = {
                    ...this.roleForm,
                    authority: JSON.stringify(data)
                };
                this.httpPut(`/role/${params.role_id}`, params).then(res => {
                    if (res.duplicate) {
                        this.$message.warning('角色重复！');
                    } else {
                        this.$message.success('角色修改成功！');
                        this.back()
                    }
                })
            },
            back() {
                this.$emit('changeTopTab', 'tableView')
            }
        }
    }
</script>

<style scoped lang="scss">
    .context_add {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
        .header {
            height: 45px;
            line-height: 45px;
            background: #fff;
            display: flex;
            justify-content: space-between;
            padding: 0 20px;
            .search {
                padding-top: 15px;
            }
        }
        .text_main {
            width: 100%;
            height: calc(100% - 110px);
            overflow: hidden;
            overflow-y: auto;
            background: #fff;
            padding: 20px 0 1px;
            .form_box {
                width: 100%;
                background: #fff;
                .form_item {
                    display: flex;
                    .title {
                        min-width: 80px;
                        height: 35px;
                        line-height: 35px;
                        padding-left: 15px;
                        padding-right: 10px;
                        text-align: right;
                        white-space: nowrap;
                        color: #8d8d8d;
                        font-size: .875rem;
                    }
                    .input_box {
                        width: calc(100% - 100px);
                    }
                    .check_box {
                        display: flex;
                        width: calc(100% - 100px);
                        line-height: 35px;
                        .btn_box {
                            margin-right: 15px;
                            .actived_btn {
                                border: 1px solid #409EFF;
                                padding: 5px;
                                color: #1989fa;
                            }
                        }
                        .right_title {
                            padding-left: 20px;
                            color: #ccc;
                            flex: 0 0 100px;
                        }
                    }
                }
            }
            .tree_box {
                position: relative;
                background: #fff;
                .btn_box {
                    position: absolute;
                    bottom: 100px;
                    right: 45%;
                    z-index: 99;
                }

                padding: 15px;
                .table_title {
                    display: flex;
                    div {
                        flex: 1;
                        height: 40px;
                        line-height: 40px;
                        font-size: 16px;
                        font-weight: 600;
                        padding-left: 15px;
                        background: #EAEAEA;
                        border-top: 1px solid #c6e2ff;
                        border-left: 1px solid #c6e2ff;
                        &:last-child {
                            border-right: 1px solid #c6e2ff;
                        }
                    }
                }
                .tree_item {
                    display: flex;
                    border: 1px solid #c6e2ff;
                    border-bottom: none;
                    &:last-child {
                        border-bottom: 1px solid #c6e2ff;
                    }
                    .one_box {
                        flex: 1;
                        height: 30px;
                        line-height: 30px;
                        padding-left: 15px;
                    }
                    .two_box {
                        flex: 2 0 33px;
                        .dis_two {
                            display: flex;
                            border: 1px solid #c6e2ff;
                            border-bottom: none;
                            border-right: none;
                            &:first-child {
                                border-top: none;
                            }
                            .three_box {
                                flex: 1;
                                height: 30px;
                                line-height: 30px;
                                padding-left: 15px;
                            }
                            .four_box {
                                flex: 1 0 15px;
                                border-left: 1px solid #c6e2ff;
                                .span_item {

                                    height: 30px;
                                    line-height: 30px;
                                    padding-left: 15px;
                                    display: block;
                                }
                            }
                        }

                    }
                }
            }
        }
        .look_text_main {
            height: calc(100% - 65px);
        }

        .bottom {
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 45px;
            line-height: 45px;
            background: #fff;
            text-align: right;
            border-top: 2px solid #F9F9F9;
            .newBtn {
                margin-right: 20px;
            }
            .table-btn {
                margin-right: 15px;
            }
        }
    }
</style>
